import * as React from 'react';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../constants/infrastructure';
import { TMapItemType } from '../../types/map';
import { IMainPromoPin } from '../../types/newbuilding/mainPromoPin';
import { SpecialPromoPin } from './SpecialPromoPin';
import * as styles from './styles.css';

export interface IMapPinProps {
  type: TMapItemType;
  mainPromoPin?: IMainPromoPin | null;
}

export function MapPin({ type, mainPromoPin }: IMapPinProps) {
  const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (mainPromoPin) {
    return <SpecialPromoPin backgroundColor={mainPromoPin.backgroundColor} imageUrl={mainPromoPin.logo} />;
  }

  if (type === 'main') {
    return <div className={styles['pin_main']} />;
  }

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['pin']}>
      <Icon color={'white_100'} />
    </div>
  );
}
